export const environment = {
  production: true,
  apiBaseUrl: 'https://api-clientsportal.elitax.app/api',
  baseUrl: 'https://api-clientsportal.elitax.app',
  apiUrl: 'https://api-clientsportal.elitax.app/api',
  useCookies: true,
  appVersion: '1.8.0',
  sentryDsn: 'https://2cf8655b354f069111810d1e5761b71c@o4509044497711104.ingest.de.sentry.io/4509112488427600',
};
